<template>
    <div :style="{ width: sidebarwidth }" class="rightdetailssidebar" v-if="trigger">
        <div class="firstcontent">
            <div class="sidebar-header">
                <h6>{{ t('assetManagement.Disposal.sidebarHeading.DisposalPlanning') }}</h6>
                <i class="pi pi-arrow-right" @click="closedetailsrightsidebar"> </i>
            </div>
            <div class="sidebar-content ">
                <b-container fluid class="">
                    <b-row class="align-items-center asset_details">
                        <b-col lg="12">
                            <div class="field mt-2">
                                <p class="light-txt">{{ t('assetManagement.Disposal.Asset Name')
                                    }} : <span class="normal-txt">{{ propsdatas?.AssetName }}</span></p>
                            </div>
                        </b-col>
                        <b-col lg="12">
                            <div class="field">
                                <p class="light-txt">{{ t('assetManagement.Disposal.ApprovedDate')
                                    }} : <span class="normal-txt">{{ propsdatas?.ApprovalDate }}</span></p>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="6">
                            <div class="field mb-0 mt-0">
                                <CustomDropdown :label="t('assetManagement.Disposal.DisposalMethod')"
                                    :name="t('assetManagement.Disposal.DisposalMethod')"
                                    v-model="updateplan.proposedDisposalMethod" :items="disposaloptions"
                                    :rules="{ required: true }" :required-icon="true" />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="calendardate pt-0" lg="6">
                            <div class="field mt-3">
                                <label class="mb-2">{{ t('assetManagement.Disposal.Date') }}</label>
                                <DatePicker :showlabel="false" v-model="updateplan.ScheduledDisposalDate"
                                    :name="t('assetManagement.Disposal.Date')" id="SelectDate"
                                    @date-select="DateFilterOnChange" :rules="{ required: true }"
                                    :required-icon="true" />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="my-3">
                        <b-col lg="6">
                            <div class="field">
                                <CustomDropdown :label="t('assetManagement.Disposal.AssignedTo')"
                                    :name="t('assetManagement.Disposal.AssignedTo')" v-model="updateplan.assignedTo"
                                    :items="assignoptions" :rules="{ required: true }" :required-icon="true" />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="9">
                            <div class="field">
                                <TextArea :label="t('assetManagement.Disposal.DisposalInstructions')"
                                    :name="t('assetManagement.Disposal.DisposalInstructions')"
                                    v-model="updateplan.disposalInstructions" :rows="3" />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3 mb-4 document_confirmation_scetion"
                        v-if="updateplan.proposedDisposalMethod === 2">
                        <b-col lg="12" class="">
                            <label>{{
                                t('assetManagement.Disposal.DisposalConfirmation.DisposalConfirmation') }}</label>
                            <div class="d-flex align-items-center">
                                <Checkbox v-model="updateplan.RecycleConfirmed" inputId="ingredient1" name="recyle"
                                    value="1" />
                                <label for="ingredient1" class="ms-2">{{
                                    t('assetManagement.Disposal.DisposalConfirmation.Assetform') }}</label>
                            </div>
                            <div class="d-flex align-items-center my-2">
                                <Checkbox v-model="updateplan.RecycleConfirmed" inputId="ingredient2" name="recyle"
                                    value="2" />
                                <label for="ingredient2" class="ms-2">
                                    {{ t('assetManagement.Disposal.DisposalConfirmation.Datacertificate') }}</label>
                            </div>
                            <div class="d-flex align-items-center">
                                <Checkbox v-model="updateplan.RecycleConfirmed" inputId="ingredient3" name="recyle"
                                    value="3" />
                                <label for="ingredient3" class="ms-2">
                                    {{ t('assetManagement.Disposal.DisposalConfirmation.recyclingdocument') }}</label>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <Footer @cancel="IsClear" @save="confirmPopupHandle" label="Save Plan" />
                    </b-row>
                </b-container>
            </div>
        </div>
        <div v-if="showdetails" class="secondcontent">
            <div class="sidebar-header">
                <h6>{{ t('assetManagement.Disposal.sidebarHeading.DisposalExecution') }}</h6>
                <i class="pi pi-times" @click="closedetails"> </i>
            </div>
            <div class="sidebar-content">
                <b-container fuild>

                    <b-row>
                        <b-col class="calendardate pt-0" lg="6">
                            <div>
                                <label>{{
                                    t('assetManagement.Disposal.ExecutionDetails.ExecutionDetails') }}</label>
                                <div class="field mt-3">
                                    <label class="mb-2">{{
                                        t('assetManagement.Disposal.ExecutionDetails.ActualDisposalDate') }}</label>
                                    <DatePicker :showlabel="false" v-model="updateplan.actualDisposalDate"
                                        :name="t('assetManagement.Disposal.ExecutionDetails.ActualDisposalDate')"
                                        id="ActualDisposalDate" label="" @date-select="DateFilterOnSelect"
                                        :rules="{ required: true }" :required-icon="true" />
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row v-if="updateplan.proposedDisposalMethod === 1">
                        <b-col lg="6">
                            <div class="field">
                                <TextField type="text" v-model="updateplan.actualDisposalProceeds"
                                    :rules="{ required: true }" :required-icon="true"
                                    :name="t('assetManagement.Disposal.ExecutionDetails.ActualDisposalProceeds')"
                                    :label="t('assetManagement.Disposal.ExecutionDetails.ActualDisposalProceeds')" />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row v-if="updateplan.proposedDisposalMethod === 1">
                        <label>{{
                            t('assetManagement.Disposal.BuyersInformation.BuyersInformation') }}</label>
                        <b-col lg="6">
                            <div class="field">
                                <TextField type="text" v-model="updateplan.buyerInformation" :rules="{ required: true }"
                                    :required-icon="true" :name="t('assetManagement.Disposal.BuyersInformation.Name')"
                                    :label="t('assetManagement.Disposal.BuyersInformation.Name')" />
                            </div>
                        </b-col>
                        <b-col lg="6">
                            <div class="field">
                                <TextField type="text" v-model="updateplan.contact" :rules="{ required: true }"
                                    :required-icon="true"
                                    :name="t('assetManagement.Disposal.BuyersInformation.contact')"
                                    :label="t('assetManagement.Disposal.BuyersInformation.contact')" />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row v-if="updateplan.proposedDisposalMethod === 3" class="">
                        <label>{{
                            t('assetManagement.Disposal.BuyersInformation.RecipientInformation') }}</label>
                        <b-col lg="6">
                            <div class="field">
                                <TextField type="text" v-model="updateplan.organizationName" :rules="{ required: true }"
                                    :required-icon="true" :name="t('assetManagement.Disposal.BuyersInformation.Name')"
                                    :label="t('assetManagement.Disposal.BuyersInformation.Name')" />
                            </div>
                        </b-col>
                        <b-col lg="6">
                            <div class="field">
                                <TextField type="text" v-model="updateplan.contact" :rules="{ required: true }"
                                    :required-icon="true"
                                    :name="t('assetManagement.Disposal.BuyersInformation.contact')"
                                    :label="t('assetManagement.Disposal.BuyersInformation.contact')" />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3 mb-4 document_confirmation_scetion">
                        <b-col lg="12" class="">
                            <label>{{
                                t('assetManagement.Disposal.DisposalConfirmation.DisposalConfirmation') }}</label>
                            <div class="d-flex align-items-start">
                                <Checkbox v-model="updateplan.disposalConfirmed" inputId="ingredient1" name="pizza"
                                    value="1" />
                                <label for="ingredient1" class="ms-2">{{
                                    t('assetManagement.Disposal.ExecutionDetails.confirmmsg') }}</label>
                            </div>
                            <div class="d-flex align-items-center my-2">
                                <Checkbox v-model="updateplan.disposalConfirmed" inputId="ingredient2" name="pizza"
                                    value="2" />
                                <label for="ingredient2" class="ms-2">{{
                                    t('assetManagement.Disposal.ExecutionDetails.confirmdoc') }}</label>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <Footer @cancel="IsClear" @save="completeDisposalHandle()" label="Complete Disposal" />
                    </b-row>
                </b-container>
            </div>
        </div>
    </div>
    <Dialog :modal="true" v-model:visible="confirm_pop" header="Confirmation"
        :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '25vw' }">
        <b-container fuild>
            <b-row>
                <b-col lg="12">
                    <div class="field">
                        <p>Do yo want to complete the disposal ?</p>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <Footer @cancel="completeDisposalHandle()" label="yes" CancelLabel="No" @save="executionHandle" />
            </b-row>
        </b-container>
    </Dialog>
    <CreateSuccessully :visible="successpop" content="Disposal Completed Successfully" @ok="closetrigger()" />
</template>
<script lang="ts">
import { defineComponent, ref, computed, watch, onMounted } from 'vue'
import CustomDropdown from '../../../../../../../components/FormComponents/Dropdown.vue';
import TextArea from '../../../../../../../components/FormComponents/TextArea.vue';
import Footer from '../../../../../../../components/FormComponents/Footer.vue';
import DatePicker from '../../../../../../../components/FormComponents/DatePicker.vue';
import Checkbox from 'primevue/checkbox';
import moment from "moment";
import ExecutionDisposalpopup from './ExecutionDisposalpopup.vue';
import TextField from '../../../../../../../components/FormComponents/TextInput.vue';
import StoreService from '../../../../../../../modules/Inventory/Service/StoreService';
import { useRouter, useRoute } from "vue-router";
import { DisposalplanningModels } from '../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/model/Disposal/disposalModel'
import { useI18n } from 'vue-i18n';
import CompleteDisposal from './CompleteDisposal.vue';
import DisposalService from '../../../../../../../modules/Inventory/Service/AssetManagement/DisposalService';
import CreateSuccessully from "../../../../../../../components/FormComponents/createdsuccessfully.vue";

export default defineComponent({
    components: {
        CustomDropdown,
        TextArea,
        Footer,
        DatePicker,
        Checkbox,
        ExecutionDisposalpopup,
        TextField,
        CreateSuccessully
    },
    props: {
        trigger: {
            type: Boolean,
            default: false,
        },
        datas: {
            type: Object,
            default: null
        }
    },
    setup(props, { emit }) {
        const FilterObj = ref({
            selectedDate: '',
            Date: "",
        });
        const disFilterObj = ref({
            disDates: '',
            disDate: "",
        })
        const propsdatas = ref(props.datas)
        watch(
            () => props.datas,
            (newVal: any) => {
                debugger;
                propsdatas.value = newVal;
            }
        );
        watch(
            () => props.trigger,
            (newVal: any) => {
                if (props.trigger == true) {

                    getdisposaldetails(props.datas.Id)
                }

            }, { deep: true }
        );
        const { t } = useI18n();
        const showdetails = ref(false);
        const selectedassign = ref();
        const assignoptions = ref([]);
        const instruction = ref();
        const decommissionform = ref();
        const wipingcertificate = ref();
        const recyclingagreement = ref();
        const confirm_pop = ref();
        const expected_proceeds = ref();
        const buyer_details = ref();
        const routes = useRoute();
        const executionconfirmmsg = ref();
        const successpop = ref(false)
        const disposaloptions = ref([
            { name: 'Sell', value: 1 },
            { name: 'Recycle', value: 2 },
            { name: 'Donate', value: 3 },
            { name: 'Scrap', value: 4 }
        ]);
        const selectedreason = ref();
        let StoreId = routes.query.Id
        let usersData;
        let SessionUserData = localStorage.getItem("UsersData");
        if (SessionUserData !== null) {
            usersData = JSON.parse(SessionUserData);
        }
        let HospitalId = Number(usersData.OrganizationId);
        const updateplan = ref<DisposalplanningModels>({
            isNew: false,
            isModified: false,
            isDeleted: false,
            isActive: false,
            createdAt: moment().format(
                "YYYY-MM-DDTHH:mm:ss.SSSZ"
            ),
            modifiedAt: moment().format(
                "YYYY-MM-DDTHH:mm:ss.SSSZ"
            ),
            createdBy: 0,
            modifiedBy: 0,
            createdByName: "",
            modifiedByName: "",
            entityId: 0,
            entityOperationId: 0,
            deptRoleId: 0,
            hospitalId: 0,
            branchId: 0,
            fromStoreBranchId: 0,
            toStoreBranchId: 0,
            isEntitySMS: 0,
            branchName: "",
            fromStoreBranchName: "",
            toStoreBranchName: "",
            taskStatus: 0,
            taskExpiryDate: moment().format(
                "YYYY-MM-DDTHH:mm:ss.SSSZ"
            ),
            taskName: "",
            taskPriority: 0,
            responseTimeInHours: 0,
            isApprovalRequired: true,
            levelsOfApproval: 0,
            id: 0,
            assetID: 0,
            flaggedDate: "2024-10-28T00:00:00.000+05:30",
            reasonForDisposal: 0,
            proposedDisposalMethod: ref(),
            expectedProceeds: 0,
            approvalStatus: "1",
            approvalDate: moment().format(
                "YYYY-MM-DDTHH:mm:ss.SSSZ"
            ),
            approvedBy: "",
            rejectionReason: "",
            ScheduledDisposalDate: "",
            assignedTo: ref(),
            disposalInstructions: "",
            actualDisposalDate: '2024-10-28T00:00:00.000+05:30',
            actualDisposalMethod: "",
            actualDisposalProceeds: ref(),
            buyerInformation: "",
            status: "2",
            disposalNotes: "",
            updatedBy: "",
            updatedAt: moment().format(
                "YYYY-MM-DDTHH:mm:ss.SSSZ"
            ),
            requiredDocumentation: "",
            disposalConfirmed: "",
            otherReason: "",
            organizationName: "",
            contact: "",
            RecycleConfirmed: ""

        })
        async function savePlan() {
            console.log(updateplan.value)
            confirm_pop.value = false;
            alert('saveplan')
            await completeDisposalHandle()
        }
        function confirmPopupHandle() {
            confirm_pop.value = true;
        }
        const sidebarwidth = computed(() => {
            return showdetails.value ? '65rem' : '30rem';
        });
        const DateFilterOnChange = () => {
            FilterObj.value.Date = moment(FilterObj.value.selectedDate).format("YYYY-MM-DD");
        };
        const DateFilterOnSelect = () => {
            disFilterObj.value.disDate = moment(disFilterObj.value.disDates).format("YYYY-MM-DD");
        };
        function closedetailsrightsidebar() {
            emit("triggerclose")
        };
        function executionHandle() {
            confirm_pop.value = false;
            showdetails.value = true;
        }
        function closedetails() {
            showdetails.value = false;
            emit("triggerclose")
        }
        function closetrigger() {
            emit("triggerclose")
            showdetails.value = false;
            successpop.value = false;
            IsClear();
        }
        async function LoadUser() {
            try {
                const data_response = await StoreService.ListUserByStoreId(StoreId, HospitalId);
                assignoptions.value = data_response["result"].map((item) => {
                    item.name = item.UserName;
                    item.value = item.ID;
                    return item;
                });
            } catch (error) {
                console.log(error)
            }
        }
        onMounted(() => {
            LoadUser()
        });

        async function getdisposaldetails(data) {
            const data_response = await DisposalService.updateplangetdata(data);

            console.log('datass', data_response["result"])
            updateplan.value.proposedDisposalMethod = Number(data_response["result"]['ProposedDisposalMethod']);
            if (data_response["result"]['ScheduledDisposalDate']) {
                updateplan.value.ScheduledDisposalDate = data_response["result"]['ScheduledDisposalDate'];
                updateplan.value.disposalInstructions = data_response["result"]['DisposalInstructions'];
                updateplan.value.assignedTo = Number(data_response["result"]['AssignedTo']);
                // showdetails.value= true;
            }
        }
        async function completeDisposalHandle() {

            confirm_pop.value = false;

            try {
                if (updateplan.value.disposalConfirmed) {
                    updateplan.value.status = "3"
                    updateplan.value.disposalConfirmed = updateplan.value.disposalConfirmed.join(",")
                }
                if (updateplan.value.RecycleConfirmed) {
                    updateplan.value.RecycleConfirmed = updateplan.value.RecycleConfirmed.join(",")
                }
                updateplan.value.id = props.datas.Id;
                updateplan.value.ScheduledDisposalDate = moment(updateplan.value.ScheduledDisposalDate, "DD-MM-YYYY").format("YYYY-MM-DDTHH:mm:ss.SSSZ");
                updateplan.value.actualDisposalDate = moment(updateplan.value.actualDisposalDate).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
                updateplan.value.assignedTo = Number(updateplan.value.assignedTo)
                console.log('updateplan', updateplan.value)
                const data_response = await DisposalService.updateplan(updateplan.value);
                console.log('res', data_response);
                let msg;
                msg = data_response["ErrorInfo"].ErrorCode;
                if (msg == null) {
                    successpop.value = true;
                }

            } catch (error) {
                console.log(error);
            }
        }
        function IsClear() {

        }
        return {
            IsClear,
            selectedassign,
            assignoptions,
            instruction,
            FilterObj,
            recyclingagreement,
            wipingcertificate,
            decommissionform,
            // isClear,
            confirm_pop,
            confirmPopupHandle,
            disposaloptions,
            selectedreason,
            expected_proceeds,
            buyer_details,
            closedetailsrightsidebar,
            sidebarwidth,
            showdetails,
            executionHandle,
            closedetails,
            propsdatas,
            usersData,
            StoreId,
            t,
            completeDisposalHandle,
            updateplan,
            DateFilterOnChange,
            DateFilterOnSelect,
            savePlan,
            executionconfirmmsg,
            successpop,
            closetrigger,
            getdisposaldetails
            // time 
        };
    },
});
</script>
<style lang="scss" scoped>
.document_confirmation_scetion {
    font-size: 14px;
    line-height: 18px;
}

.rightdetailssidebar {
    display: flex;
    position: fixed;
    top: 0;
    right: 0;
    height: 100%;
    transition: all 0.3s ease;
    background: #ffffff;
    border: 1px solid #e1e1e1;
    z-index: 100;

    .sidebar-header {
        position: relative;
        display: flex;
        gap: 10px;
        justify-content: space-between;
        padding: 15px;
        border-bottom: 1px solid #e1e1e1;
        border-right: 1px solid #e1e1e1;

        .pi-arrow-right {
            position: absolute;
            left: -15px;
            top: 60px;
            background: #e1e1e1;
            font-size: 14px;
            height: 30px;
            width: 30px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .firstcontent {
        width: 30rem;
        flex-shrink: 0;
    }

    .secondcontent {
        width: 35rem;
        //flex-shrink: 0;
    }

    .sidebar-content {
        padding: 0px 15px 15px;
        max-height: calc(100vh - 44.8px);
        overflow: auto;
        transition: width 0.3s ease;
        flex-grow: 1;
    }
}
</style>
